module.exports = __webpack_public_path__ + "img/how_to_use03_img.9e17821e.png";